import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GripSubscription } from '../models';
import { BASE_URL } from '@teamfoster/sdk/ssr';

@Injectable({
  providedIn: 'root',
})
export class GripSubscriptionsService {
  private http = inject(HttpClient);
  private BASE_URL = inject(BASE_URL, { optional: true })!;

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {}

  getSubscriptions(token: string) {
    return this.http.get<GripSubscription[]>(`${this.BASE_URL}api/my-rova/notifications/grip/subscriptions?token=${token}`);
  }

  saveSubscription(subscription: GripSubscription, token: string) {
    return this.http.post<GripSubscription>(`${this.BASE_URL}api/my-rova/notifications/grip/subscriptions?token=${token}`, subscription);
  }

  deleteSubscription(id: number, token: string) {
    return this.http.delete<GripSubscription>(`${this.BASE_URL}api/my-rova/notifications/grip/subscriptions/${id}?token=${token}`);
  }

  deleteSubscriptions(token: string) {
    return this.http.delete<any>(`${this.BASE_URL}api/my-rova/notifications/grip/subscriptions?token=${token}`);
  }
}
